import { call, put, takeLatest } from "redux-saga/effects";
import {
    updateConsentRequest,
    updateConsentSuccess,
    updateConsentFailure,
} from "../slice/consentSlice";

import { updateConsentApi } from "@src/api/apiService";
import { getApiError } from "@src/utils/apiError";

function* updateConsent(
    action: ReturnType<typeof updateConsentRequest>
): Generator<any, void, any> {
    try {
        const response = yield call(
            updateConsentApi,
            action.payload
        );

        yield put(
            updateConsentSuccess(response.data)
        );
    } catch (error: unknown) {

        const apiError = getApiError(error);

        yield put(
            updateConsentFailure(
                apiError.message
            )
        );
    }
}

export function* consentSaga() {
    yield takeLatest(
        updateConsentRequest.type,
        updateConsent
    );
}